import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from 'react'
import { Trans } from 'react-i18next'

interface GroupTitleProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    PropsWithChildren {
  afterChildren?: React.ReactNode
  isFirst?: boolean
}

export const GroupTitle = ({
  style,
  children,
  afterChildren,
  isFirst,
}: GroupTitleProps) => (
  <>
    {!isFirst && <div className="my-6 h-[1px] w-full bg-bgTertiary" />}
    <div style={style} className="text-heading-5">
      <Trans parent="span">{children}</Trans>
      {afterChildren}
    </div>
  </>
)
